import Form from "react-bootstrap/Form";
import styles from "./Orders.module.css";
import { FormProvider, useForm } from "react-hook-form";
import StudySubjectInputs from "./StudySubjectInputs/StudySubjectInputs";
import { OrderFormDetails } from "../../models/order.interface";
import SubjectVisitInputs from "./SubjectVisitInputs/SubjectVisitInputs";
import { IStudySubject } from "../../models/order.interface";
import { useState } from "react";
import { IStudy } from "../../models/study.interface";

const Orders = () => {
  const formMethods = useForm<OrderFormDetails>();

  const [subject, setSubject] = useState<IStudySubject>();
  const [study, setStudy] = useState<Partial<IStudy>>();
  const [existsInOtherStudyName, setExistsInOtherStudyName] = useState<string>(
    ""
  );

  const onReset = (r = {}) => {
    setSubject({});
    setExistsInOtherStudyName("");
  };

  return (
    <FormProvider {...formMethods}>
      <Form className={`${styles.ordersWrapper} m-auto`}>
        <StudySubjectInputs
          updateStudy={setStudy}
          updateSubject={setSubject}
          otherStudyName={existsInOtherStudyName}
          updateOtherStudyName={setExistsInOtherStudyName}
        />
        <SubjectVisitInputs
          study={study ?? {}}
          subject={subject ?? {}}
          onReset={onReset}
        />
      </Form>
    </FormProvider>
  );
};

export default Orders;
